import {
  type ChatTransport,
  convertToModelMessages,
  streamText,
  type ToolSet,
  type UIMessage,
  type UIMessageChunk,
} from 'ai';

import { dixaGateway } from './provider';

/**
 * Builds a transport that runs the AI SDK agent loop from vercel in the browser
 * using Open SSE streams, facilitated by our own open ai compatible gateway.
 */
export const createBrowserChatTransport = (
  buildTools: () => ToolSet,
  getMainPrompt: () => string,
): ChatTransport<UIMessage> => ({
  async sendMessages({ chatId, messages, abortSignal }) {
    const modelMessages = await convertToModelMessages(messages);
    const result = streamText({
      model: dixaGateway(getMainPrompt()),
      messages: modelMessages,
      tools: buildTools(),
      abortSignal,
      headers: { traceparent: `00-${chatId}-4fe7d85c49cf1379-01` },
    });
    return result.toUIMessageStream() as ReadableStream<UIMessageChunk>;
  },
  async reconnectToStream() {
    return null;
  },
});
